import { FunctionComponent } from "react";
import RadioButton from "./RadioButton";

export interface PropertyOption {
  label: string;
  value: number | string;
}

export interface RadioButtonGroupType {
  id: string;
  active: string | boolean | number | undefined;
  label: string;
  error?: boolean;
  errorText?: string;
  setValue: (value: number | string, id: string) => void;
  showLabel?: boolean;
  properties: { options: PropertyOption[] };
}

const RadioButtonGroup: FunctionComponent<RadioButtonGroupType> = ({
  id,
  setValue,
  active,
  showLabel,
  error,
  errorText,
  label,
  properties,
}) => {
  const options = properties.options;
  const radioButtons = options.map((option) => {
    return (
      <div
        className={`px-1 py-1 ${
          options.length % 3 === 0 ? "w-full md:w-1/3" : "w-1/2"
        } lg:px-2 lg:py-2`}
        key={option.value}
      >
        <RadioButton
          {...option}
          isActive={option.value === active}
          setValue={() => setValue(option.value, id)}
        />
      </div>
    );
  });
  return (
    <div>
      <p className={`text-sm mb-2 ${!label || !showLabel ? "hidden" : null}`}>
        {label}
      </p>
      <div className="flex flex-wrap items-stretch -mx-1 -my-1 lg:-my-2 lg:-mx-2">
        {radioButtons}
      </div>
      {error ? <p className="mt-2 text-xs text-red-500">{errorText}</p> : null}
    </div>
  );
};

export default RadioButtonGroup;
